/** Why the live assistant is not usable right now (#13384 F15): the chat only runs on a SAVED item description. */
export enum enumHtsAssistantLock {
  /** The line has no description yet. */
  NoDescription = 'noDescription',
  /** Standalone host: the description typed in the form differs from the saved one (press Find HTS to continue). */
  DraftChanged = 'draftChanged',
  /** The line is already verified (catalog, earlier answer, similar product, broker…) and holds no active conversation. */
  Validated = 'validated',
  /** The assistant said "no answer" for this product earlier (e.g. a duplicated line) and no conversation is active here. */
  NoAnswerEarlier = 'noAnswerEarlier',
}
